/**
 * @generated SignedSource<<22a8ba4ab6706556d2e6da85202afba6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserRecommendationsGrid_user$data = {
  readonly twoTowerModelItemRecommendations: {
    readonly items: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsRecommendationTile_item">;
    }>;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsRecommendationTile_user">;
  readonly " $fragmentType": "UserRecommendationsGrid_user";
};
export type UserRecommendationsGrid_user$key = {
  readonly " $data"?: UserRecommendationsGrid_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsGrid_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "recommendationItemsCount"
    },
    {
      "defaultValue": "PERSONALIZED",
      "kind": "LocalArgument",
      "name": "recommendationType"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserRecommendationsGrid_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserRecommendationsRecommendationTile_user"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "type",
          "variableName": "recommendationType"
        }
      ],
      "concreteType": "UserRecommendations",
      "kind": "LinkedField",
      "name": "twoTowerModelItemRecommendations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "recommendationItemsCount"
            }
          ],
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "fetchFavorites",
                  "value": true
                },
                {
                  "kind": "Variable",
                  "name": "isTrade",
                  "variableName": "isTrade"
                },
                {
                  "kind": "Variable",
                  "name": "priceBookName",
                  "variableName": "priceBookName"
                },
                {
                  "kind": "Variable",
                  "name": "userId",
                  "variableName": "userId"
                }
              ],
              "kind": "FragmentSpread",
              "name": "UserRecommendationsRecommendationTile_item"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "64db250f00acacc0810a095ee50be95c";

export default node;
